// src/layout/Header.tsx
import React from 'react';
import { useLocation } from 'react-router-dom';
import { Cog6ToothIcon } from '@heroicons/react/24/outline';
import NotificationBell from '../features/notifications/components/NotificationBell';
import { usePreferencesUIStore } from '@/store/preferencesUIStore';
import ChatCommandBar from './ChatCommandBar';

interface HeaderProps {
  currentViewTitle?: string;
  isSidebarCollapsed?: boolean;
}

const Header: React.FC<HeaderProps> = ({ currentViewTitle = "Chat" }) => {
  const userInitials = "U";
  const location = useLocation();
  const { open: openPreferences } = usePreferencesUIStore();

  const isChatRoute = location.pathname === '/chat' || location.pathname.startsWith('/chat/');

  return (
    <header className="h-12 flex-shrink-0 flex items-center justify-between px-4
                     bg-[var(--brand-surface-header)]
                     text-[var(--brand-text-primary)]
                     border-b border-[var(--brand-border)]
                     transition-colors duration-300 ease-in-out
                     relative z-40">
      {/* Left side — ChatCommandBar on chat routes, view title otherwise */}
      <div className="flex items-center min-w-0 flex-1 mr-4">
        {isChatRoute ? (
          <ChatCommandBar />
        ) : (
          <h1 className="text-lg font-semibold text-[var(--brand-text-secondary)] transition-colors duration-300 ease-in-out hidden sm:block">
            {currentViewTitle}
          </h1>
        )}
      </div>

      {/* Right side — Notifications, Settings, User Profile */}
      <div className="flex items-center space-x-2 flex-shrink-0">
        <NotificationBell />
        <button
          id="settings-menu-button"
          onClick={openPreferences}
          className="p-1.5 rounded-full text-[var(--brand-text-tertiary)] hover:bg-[var(--brand-surface-hover)] hover:text-[var(--brand-text-secondary)] focus:outline-none focus:ring-2 focus:ring-[var(--brand-focus-ring)] transition-colors"
          title="Settings"
          aria-haspopup="dialog"
        >
          <Cog6ToothIcon className="h-5 w-5" />
        </button>

        <button
          onClick={() => {
            localStorage.removeItem('chat-storage');
            window.location.href = "https://app.webelievesoftware.com/chat";
          }}
          className="w-7 h-7 bg-[var(--brand-accent-primary)] rounded-full flex items-center justify-center text-[var(--brand-accent-contrast)] text-xs font-semibold focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-offset-[var(--brand-surface-header)] focus:ring-[var(--brand-focus-ring)]"
          title="Start New Chat Session"
        >
          {userInitials}
        </button>
      </div>
    </header>
  );
};

export default Header;
